import type { MatcherDefinition } from "@venn-lang/sdk";
import { header } from "./header.js";

export const httpMatchers: MatcherDefinition[] = [header];
